<template>
  <span>
  <img src="/clientV2/static/gfx/files.svg"
       class="iconBtn transition"
       v-tippy="{ placement : 'top'}"
       id="toolBarFilesIcon"
       @click="menuToggle = true"
       :title="(options.title) ? options.title : 'יצא קבצים'">

  <ul class="excelList"
      v-if="menuToggle === true"
      v-menufocus:opt="{class: 'excelList', trigger: 'menuToggle', el: 'toolBarFilesIcon'}">
    <li @click="emitEvent({method:'showUploadWindow'})" v-if="options.list.includes('showUploadWindow')">
      <a>העלה קובץ אקסל</a>
    </li>
    <li @click="emitEvent({method:'showPastUploadWindow'})" v-if="options.list.includes('showPastUploadWindow')">
      <a>העלה קובץ תשלומי עבר</a>
    </li>
     <li @click="emitEvent({method: 'exportExcelPaid'})" v-if="options.list.includes('exportExcelPaid')">
      <a>יצא לאקסל - מצב גבייה</a>
    </li>
    <li @click="emitEvent({method: 'exportExcelDebt'})" v-if="options.list.includes('exportExcelDebt')">
      <a>יצא לאקסל - מצב חובות</a>
    </li>
    <li @click="emitEvent({method: 'exportExcel'})" v-if="options.list.includes('exportExcel')">
      <a>יצא לאקסל</a>
    </li>
    <li @click="emitEvent({method: 'exportPdf'})" v-if="options.list.includes('exportPdf')">
      <a>יצא לPDF</a>
    </li>
    <li @click="emitEvent({method: 'exportPdfPaid'})" v-if="options.list.includes('exportPdfPaid')">
      <a>יצא לPDF - מצב גבייה</a>
    </li>
     <li @click="emitEvent({method: 'exportPdfDebt'})" v-if="options.list.includes('exportPdfDebt')">
      <a>יצא לPDF - מצב חובות</a>
    </li>
    <li @click="emitEvent({method: 'printPdfPaid'})" v-if="options.list.includes('printPdfPaid')">
      <a>הדפס דו"ח - מצב גבייה</a>
    </li>
    <li @click="emitEvent({method: 'printPdfDebt'})" v-if="options.list.includes('printPdfDebt')">
      <a>הדפס דו"ח - מצב חובות</a>
    </li>
    <li @click="emitEvent({method: 'printPdf'})" v-if="options.list.includes('printPdf')">
      <a>הדפס דו"ח</a>
    </li>
    <li @click="emitEvent({method: 'printPdf'})" v-if="options.list.includes('printPdfMaintenance')">
      <a>דו"ח אחזקה - הדפסה</a>
    </li>
      <li @click="emitEvent({method: 'exportPdf'})" v-if="options.list.includes('exportPdfMaintenance')">
      <a>דו"ח אחזקה - PDF</a>
    </li>
    <li @click="emitEvent({method: 'exportExcel'})" v-if="options.list.includes('exportExcelMaintenance')">
      <a>דו"ח אחזקה - אקסל</a>
    </li>
    <li @click="emitEvent({method: 'printCombined'})" v-if="options.list.includes('printCombined')">
      <a></a>דו"ח משולב אחזקה ותקלות - הדפסה</a>
    </li>
      <li @click="emitEvent({method: 'pdfCombined'})" v-if="options.list.includes('pdfCombined')">
      <a>דו"ח משולב אחזקה ותקלות PDF</a>
    </li>
     <li @click="emitEvent({method: 'excelCombined'})" v-if="options.list.includes('excelCombined')">
      <a>דו"ח משולב אחזקה ותקלות אקסל</a>
    </li>
  </ul>
  </span>
</template>

<script>
  export default {
    name: 'FilesElement',
    props: ['options'],
    data () {
      return {
        menuToggle: false
      }
    },
    methods: {
      emitEvent: function (data) {
        this.menuToggle = false
        this.$emit('emit', data)
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/style.less";

  ul {
    li {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/toolbar/FilesElement.vue